module.exports = __webpack_public_path__ + "img/network-backgtound.b3d76c65.png";